var ws, roomId = '', curUserId = '', timeInterval, activeClose = false, autoCloseTimes = 0;
var wsInitCb, wsCloseCb;
var wsURL = 'wss://ws.yxdxt.com:7273'
var WS = {
    /**
     * 创建并初始化websocket
     */
    initWebSocket(id, initCb, closeCb) {
        // 保存一些变量
        roomId = id;
        activeClose = false;
        if(initCb) { wsInitCb = initCb; }
        if(closeCb) { wsCloseCb = closeCb; }

        // 创建websocket
        ws = new WebSocket(wsURL);
        // 当socket连接打开时，输入用户名
        ws.onopen = function() {
            WS.onOpenWS();
        };
        // 当有消息时根据消息类型显示不同信息
        ws.onmessage = function(e) {
            WS.onGetMessageWS(e, wsInitCb);
        }; 
        // 当重连的时候
        ws.onreconnect = function() {
            WS.onReConnectWS();
        };
        // 监听websocket关闭事件
        ws.onclose = function() {
            WS.onCloseWS(wsCloseCb);
        };
        // 监听websocket出错事件
        ws.onerror = function(evt) {
            console.error("websocket on error---出现错误", evt, evt.code);
        };
    },
    /**
     * 退出论盘的时候，主动关闭ws
     */
    closeWebSocket() {
        activeClose = true;

        // 关闭websocket实例
        if(ws && ws != null){
            ws.close();
            ws = null;
        }
        // 清除定时发送心跳包
        WS.clearTimeInterval();
    },
    /**
     * 连接建立时发送登录信息
     */
    onOpenWS() {
        // Todo:::for test
        var token = AppFate.$store.state.userData.token ? AppFate.$store.state.userData.token : 'eyJpdiI6ImJJc05hYkFseE0xYkFLamF0REZZTFE9PSIsInZhbHVlIjoiTFQ1bzB0MGRYNHh3N2lvU25XSnFUUT09IiwibWFjIjoiYTU3NzAyYTBjNTc1ZGRhMGQ5NDE4YTYwNjc0NWVmMWVhMzA2Mzc3MWZjYzU0OTcyYmNjZjMyNDcxMWVmZDU4YSJ9';
        var loginData = {
            token: token,
            type: 'login',
            rid: roomId
        }
        console.log("websocket握手成功，发送登录数据:", loginData);
        ws.send(JSON.stringify(loginData));

        // 定时发送心跳包:间隔时间为30s
        WS.clearTimeInterval();
        timeInterval = setInterval(() => {
            ws.send('{"type":"pong"}');
        }, 30000);
    },
    /**
     * 删除发送心跳包的定时器
     */
    clearTimeInterval() {
        if(timeInterval) {
            clearInterval(timeInterval);
            timeInterval = null;
        }
    },
    /**
     * 接收到服务端发来的websocket消息
     * @param {返回数据包} e 
     */
    onGetMessageWS(e, cbFunc) {
        var data = JSON.parse(e.data);
        switch(data['type']) {
            case 'login':
                // 登录成功返回
                console.log('login------', data.data, cbFunc)
                AppFate.$store.dispatch('discuss/getWSLogin', data.data);
                curUserId = data.data.uid;
                // 执行初始化ws后登录成功的回调函数::这里再拉取聊天记录列表数据
                if(cbFunc && typeof(cbFunc) == 'function') {
                    cbFunc();
                }
                //{"type":"login","client_id":xxx,"client_name":"xxx","client_list":"[...]","time":"xxx"}
                // say("", data.data.nickname,  data.data.nickname+' 加入了聊天室', data['time']);
                break;
            case 'say':
                // 聊天发言
                // //{"type":"say","from_client_id":xxx,"to_client_id":"all/client_id","content":"xxx","time":"xxx"}
                // onGetMessageWS------ {"code":200,"data":{"type":"say","msg_type":1,"content":"234657987","time":1575851457,"userInfo":{"uid":"101238","nickname":"科达"},"id":"289110"},"type":"say","msg":""}
                console.log('say------', data.data, data.data.userInfo['nickname'], data.data['content'], data.data['time'])
                AppFate.$store.dispatch('discuss/getWSMessage', data.data);
                // say("", data.data.userInfo['nickname'], data.data['content'], data.data['time']);
                break;
            case 'logout':
                // 用户退出成功返回
                // //{"type":"logout","client_id":xxx,"time":"xxx"}
                // say(data['from_client_id'], data['from_client_name'], data['from_client_name']+' 退出了', data['time']);
                // delete client_list[data['from_client_id']];
                // flush_client_list();
                break;
            default:
                break;
        }
    },

    /**
     * 客户端发送消息到服务端
     * @param {发送消息参数} params 
     */
    sendMessageWS(params) {
        if(ws && ws.readyState == 1) {
            var newParams = Object.assign({type: 'say'}, params);
            console.log('sendMessageWS--------', params, newParams)
            ws.send(JSON.stringify(newParams));
        }
    },

    /**
     * 关闭websocket
     */
    onCloseWS(cbFunc) {
        // 清除定时发送心跳包
        WS.clearTimeInterval();
        console.log('ws-------onclose-----关闭', activeClose)

        if(!activeClose) {
            console.log("连接自动关闭，定时重连");
            if(autoCloseTimes < 3) {
                setTimeout(() => {
                    autoCloseTimes++;
                    WS.initWebSocket(roomId);
                }, 1000);
            }else {
                // 自动重连的次数超过5次之后，刷新页面::::刷新页面之后，会回到列表页
                // 弹出弹框，提示手动刷新
                if(cbFunc && typeof(cbFunc) == 'function') {
                    cbFunc();
                }
            }
        }
    },

    /**
     * 重连websocket
     */
    onReConnectWS() {
        console.log('onReConnectWS------')
        // WS.initWebSocket(roomId);
    }
}

export {
    WS
}
